<template>
  <b-form-group
    label="Metin Alanı"
    label-for="text2"
  >
    <validation-provider
      #default="{ errors }"
      name="Metin Alanı"
      rules="required"
    >
      <b-form-textarea
        id="text2"
        v-model="itemData.text2"
        placeholder="Metin Alanı"
        rows="10"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'Text2Content',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
